var Ripple = require('ripple-lib')
var constants = require('./constants')

var ripple = exports['nodes'] = new Ripple.Remote({
   servers: [
  {
    host: 'wrt9.wrcoin.io',
    port: 443,
    secure: true
  },
  {
    host: 'wrt10.wrcoin.io',
    port: 443,
    secure: true
  },
  {
    host: 'wrt11.wrcoin.io',
    port: 443,
    secure: true
  }]
})

ripple.connect()



//////////////////
// WEBPACK FOOTER
// ./src/helpers/remotes.js
// module id = 359
// module chunks = 0